import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { SessionProvider } from './context/SessionContext.jsx';
import App from './App.jsx';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './styles.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      retry: (failureCount, error) => error?.status >= 500 && failureCount < 2,
      refetchOnWindowFocus: false
    }
  }
});

/* The demo used to mount MemoryRouter here so its address bar stayed on the
   bare hostname. That is gone, and deliberately.

   MemoryRouter keeps history in memory, which means in-app navigation pushes
   NO browser history entries. The whole demo therefore occupied a single entry,
   so pressing back from anywhere - after clicking Sign in, or any outbound
   link - left the site in one step and the browser restored that single entry
   from its back/forward cache, React tree and all. What came back was the
   signed-in portal, drawn from a session that had since ended.

   With BrowserRouter each navigation is a real history entry the router
   re-evaluates, which is what makes back behave. A tidy URL was never worth
   that, and the cost was visible on the one screen prospects actually use. */

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <SessionProvider>
          <App />
        </SessionProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>
);
